import styled from 'styled-components';
import { TextField as TextFieldComponent } from '@material-ui/core';
import { IconButton as ButtonIcon } from '@mui/material';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  background: #ffffff;
  border-radius: 4px;
  padding: 20px 30px;

  @media screen and (max-width: 599px) {
    margin-top: 0;
    padding: 20px 16px;
  }
`;

export const Title = styled.h1`
  color: #6a758b;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.4px;
  margin: 0;
  padding: 0;
`;

export const ChatArea = styled.div`
  flex: 1;
  min-height: 200px;
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #dbd9d9;
  border-radius: 6px;
  padding: 12px 16px;
  background-color: #fafafa;

  /* Scroll suave */
  scroll-behavior: smooth;

  /* Customização da scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #bcc4d2;
    border-radius: 3px;

    &:hover {
      background: #6a758b;
    }
  }

  @media screen and (max-width: 599px) {
    min-height: 180px;
    max-height: 300px;
    padding: 12px;
  }
`;

export const CommentWrapper = styled.div`
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const CommentHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
  gap: 8px;
`;

export const CommentAuthor = styled.span`
  font-size: 12px;
  font-weight: 600;
  font-family: 'Montserrat';
  color: #6a758b;
  flex-shrink: 0;
`;

export const CommentDate = styled.span`
  font-size: 11px;
  font-weight: 400;
  font-family: 'Montserrat';
  color: #bcc4d2;
  flex-shrink: 0;
`;

export const CommentText = styled.div`
  font-size: 14px;
  font-weight: 500;
  font-family: 'Montserrat';
  line-height: 1.4;
  color: #000;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 10px 14px;
  word-wrap: break-word;
  word-break: break-word;
  white-space: pre-wrap;
  max-width: 100%;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;
  height: 150px;
  width: 100%;
`;

export const EmptyStateText = styled.span`
  color: #6a758b;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Montserrat';
`;

export const Form = styled.form`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: flex-start;
`;

export const InputWrapper = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const TextField = styled(TextFieldComponent)`
  width: 100%;

  .MuiOutlinedInput-root {
    font-family: 'Montserrat';
    font-size: 14px;
    background-color: #fff;
  }

  .MuiOutlinedInput-input {
    padding: 10px 14px;
    padding-bottom: 28px; /* Espaço para o contador */
  }

  .MuiOutlinedInput-multiline {
    padding: 0;
  }
`;

export const CharacterCounter = styled.div<{ isNearLimit: boolean }>`
  position: absolute;
  bottom: 10px;
  right: 14px;
  font-size: 11px;
  font-weight: 500;
  font-family: 'Montserrat';
  color: ${(props) => (props.isNearLimit ? '#c73c3c' : '#bcc4d2')};
  pointer-events: none;
  user-select: none;
`;

export const SendButton = styled(ButtonIcon)`
  width: 48px !important;
  height: 48px !important;
  min-width: 48px !important;
  background-color: #000 !important;
  color: #fff !important;
  border-radius: 8px !important;
  flex-shrink: 0;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;

  &:hover:not(:disabled) {
    background-color: #333 !important;
  }

  &:disabled {
    background-color: #e0e0e0 !important;
    color: #bcc4d2 !important;
    cursor: not-allowed;
  }

  .MuiSvgIcon-root {
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .MuiCircularProgress-root {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media screen and (max-width: 599px) {
    width: 44px !important;
    height: 44px !important;
    min-width: 44px !important;

    .MuiSvgIcon-root {
      width: 20px;
      height: 20px;
    }
  }
`;
